<app-eca-modal-host (cancelClicked)="cancelClicked()"
                    (helpClicked)="helpClicked()"
                    (saveClicked)="saveClicked()"
                    (saveAndUploadClicked)="saveAndUploadDocument()" [showSaveAndUploadButton]="true" [yesButtonText]="'Save Without Document'" [yesButtonColour]="'warning'"
                    [editButtonIcon]="['far', 'edit']"
                    [heading]="heading"
                    [isEditing]="true"
                    [noButtonIcon]="['far', 'times']"
                    [yesButtonIcon]="['far', 'save']"
                    class="modal-eca modal-eca-success"
                    noButtonColour="transparent">
  <div class="container">
    <div *ngIf="showingHelp" class="row">
      <div class="col">
        <app-eca-help-alert (helpCloseClicked)="helpClicked()" [helpHtmlText]="helpMessage"></app-eca-help-alert>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <form #contactTypeDetails="ngForm">
          <fieldset>
            <div class="container-fluid">
              <div class="row">
                <div class="col">
             
                  <app-eca-select [options]="allTrainingTypeCategory" [(selectedId)]="trainingType.trainingTypeCategoryId"
                  
                  label="Category"
                  [isReadOnly]="false"
                  popoverText="Please select a category for this Course (Optional)"
                  >
                  </app-eca-select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-eca-input [(value)]="trainingType.name" [controlId]="'ctrlTrainingTypeName'"
                                 [isReadOnly]="false"
                                 [isRequired]="true"
                                 [isValid]="!submitted || !!trainingType?.name"
                                 label="Name"
                                 popoverText="Please enter a short name for the training course/type to refer to it later"
                                 validationMessage="Please enter the name for the training course/type">
                  </app-eca-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-eca-html-editor [(content)]="trainingType.description"
                                       [isReadOnly]="false"
                                       [isRequired]="false"
                                       label="Description"
                                       popoverText="Enter the details of the training type"
                                       validationMessage="Please enter the description for the training course/type">
                  </app-eca-html-editor>
                </div>
              </div>
              <div *ngIf="isCompanyTraining" class="row">
                <div class="col">
                  <app-eca-date-picker [(dateValue)]="trainingType.heldOn"
                                       [controlId]="'ctrlTypeHeldOn'"
                                       [isRequired]="false"
                                       label="Held On"
                                       popoverText="Please enter the date that this training course was held on if applicable">
                  </app-eca-date-picker>

                </div>
              </div>
              <div *ngIf="isCompanyTraining" class="row">
                <div class="col">
                  <app-eca-date-picker [(dateValue)]="trainingType.validTo"
                                       [controlId]="'ctrlTypeValidTo'"
                                       [isRequired]="false"
                                       label="Valid To"
                                       popoverText="Please enter the date that this training course is valid to if applicable">
                  </app-eca-date-picker>

                </div>
              </div>

            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</app-eca-modal-host>
